module.exports = __webpack_public_path__ + "img/ds9308-cdc-scan.5564f958.png";